/** @jsxImportSource theme-ui */
import * as React from "react";
// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using iconTemplate.js Please refer to web/src/nessie/icons/README.md for more details
import { nessiePropCheckerWrapper } from "../../nessiePropCheckerWrapper";
import {
  NessieFunctionComponent,
  NessieComponentProps,
  colorNessieResponsivePropType,
  oneOfNessieResponsivePropType,
} from "../../propTypes";
import { NessieThemeColors } from "../../theme";
import UnstyledButton from "../../../../components/buttons/UnstyledButton";
type MusicIconProps = React.SVGProps<SVGSVGElement> &
  NessieComponentProps & {
    size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
    color?: NessieThemeColors;
    onClick?: () => void;
    cursor?: React.CSSProperties["cursor"];
    display?: React.CSSProperties["display"];
    "data-test-name"?: string;
    "aria-label"?: string;
  };

let MusicIcon: NessieFunctionComponent<MusicIconProps> = ({
  size = "m",
  color = "shale",
  onClick,
  cursor,
  display = "inline-block",
  ["data-test-name"]: dataTestName,
  ["aria-label"]: ariaLabel,
  ...props
}) => {
  const sizeInPixels = SIZES[size];
  const ButtonOrSpan = onClick ? UnstyledButton : "span";
  return (
    <ButtonOrSpan
      aria-label={ariaLabel}
      data-test-name={dataTestName}
      onClick={onClick}
      sx={{
        fontSize: sizeInPixels,
        display,
        lineHeight: 0,
        color,
        cursor,
        position: "relative",
      }}
    >
      {
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.774 4.748s-.764-.644-1.328-1.972c-.563-1.328-1.69-.845-1.69.644 0 1.449-.12 12.918-.12 12.918S4.437 14.93 5.04 20.684c0 0 3.944 4.186 7.284-2.374l-.12-9.78s6.76 2.496 3.34 6.56c0 0 .402 1.731 1.73.403 1.369-1.288 5.353-5.835-3.5-10.745z"
          />
          <mask maskUnits="userSpaceOnUse" x={5} y={2} width={15} height={20}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.774 4.748s-.764-.644-1.328-1.972c-.563-1.328-1.69-.845-1.69.644 0 1.449-.12 12.918-.12 12.918S4.437 14.93 5.04 20.684c0 0 3.944 4.186 7.284-2.374l-.12-9.78s6.76 2.496 3.34 6.56c0 0 .402 1.731 1.73.403 1.369-1.288 5.353-5.835-3.5-10.745z"
            />
          </mask>
        </svg>
      }
    </ButtonOrSpan>
  );
};

const SIZES = {
  xs: "12px",
  s: "18px",
  m: "24px",
  l: "36px",
  xl: "48px",
  xxl: "56px",
};
MusicIcon.nessiePropTypes = {
  color: colorNessieResponsivePropType,
  size: oneOfNessieResponsivePropType(["xs", "s", "m", "l", "xl", "xxl"]),
}; // ------------------------------------------
// ------------------------------------------
// DEV ONLY better prop checking

if (process.env.NODE_ENV === "development") {
  MusicIcon = nessiePropCheckerWrapper(MusicIcon);
}

export default MusicIcon;
